export default {
  API_ENDPOINT: `https://thawing-caverns-41472.herokuapp.com/api`,
  // API_ENDPOINT: `http://localhost:8000/api`,
  API_KEY: process.env.REACT_APP_API_KEY,
  TOKEN_KEY: 'myfamily-key',
  SESSION_KEY: 'session-id'
}